/* eslint-disable no-console */
import { zodResolver } from '@hookform/resolvers/zod';
import { type FieldValues, type Resolver } from 'react-hook-form';
import { type z } from 'zod';

export function zodResolverWithLogging<T extends FieldValues>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  schema: z.Schema<any, any>,
) {
  const resolver: Resolver<T> = async (data, context, options) => {
    console.log('formData', data);
    console.log(
      'validation result',
      await zodResolver(schema)(data, context, options),
    );
    return zodResolver(schema)(data, context, options);
  };
  return resolver;
}
